import { render } from "./Next2.vue?vue&type=template&id=6f8fa04a"
import script from "./Next2.vue?vue&type=script&lang=js"
export * from "./Next2.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__